import { cn } from "@/lib/utils";

const formatTimestamp = seconds => {
  const total = Math.max(0, Math.floor(seconds ?? 0));
  const minutes = Math.floor(total / 60);
  return `${minutes}:${String(total % 60).padStart(2, "0")}`;
};

/**
 * One speaker's turn. The contact's turns are shaded so a long transcript stays
 * readable at a glance.
 */
export function TranscriptTurn({ turn, label, isShaded }) {
  return (
    <li
      className={cn(
        "tw:flex tw:flex-col tw:gap-1 tw:rounded-md tw:px-3 tw:py-2",
        isShaded && "tw:bg-[var(--color-warm-gray-light)]"
      )}
    >
      <div className="tw:flex tw:items-baseline tw:gap-2">
        <span className="tw:text-sm tw:font-semibold tw:text-[var(--color-text-primary)]">
          {label}
        </span>
        <span className="tw:text-xs tw:text-[var(--color-text-muted)] tw:tabular-nums">
          {formatTimestamp(turn.start_time)}
        </span>
      </div>
      <p className="tw:text-sm tw:leading-relaxed tw:text-[var(--color-text-secondary)]">
        {turn.text}
      </p>
    </li>
  );
}

export default TranscriptTurn;
